export const ONE_DAY = 1000 * 60 * 60 * 24;
export const ONE_HOUR = 1000 * 60 * 60;
export function serializeCookie(
    name: string,
    value: string,
    expires: string,
    path: string,
    domain: string,
    secure: boolean,
) {
    expires = expires ? `;expires=${expires}` : '';
    path = path ? `;path=${path}` : '';
    domain = domain ? `;domain=${domain}` : '';
    const secureString = secure ? `;secure=${secure}` : '';

    return `${name}=${encodeURIComponent(value)}${expires}${path}${domain}${secureString}`;
}

export function setCookie(
    name: string,
    value: string,
    delay: number | null = null,
    path: string | null = null,
    domain: string | null = null,
    secure = false,
) {
    const expires = delay ? new Date(Date.now() + delay).toUTCString() : null;
    document.cookie = serializeCookie(name, value, expires, path, domain, secure);
}

export function deleteCookie(
    name: string,
    path: string | null = null,
    domain: string | null = null,
    secure = false,
) {
    const expires = new Date(0);
    document.cookie = serializeCookie(
        name,
        '_deleted',
        expires.toUTCString(),
        path,
        domain,
        secure,
    );
}

export function getCookie(name: string, cookiesValue = '') {
    const cookies =
        cookiesValue || typeof document === 'undefined' ? cookiesValue : document.cookie;
    const pairs = cookies.split(';');

    const found = pairs
        .map(pair => pair.replace(/^[ ]+/, '').replace(/[ ]$/, ''))
        .map(pair => pair.split('='))
        .find(pair => pair[0] === name);

    return found ? decodeURIComponent(found[1]) : undefined;
}
